export default {
  orgTargets: [],
  orgTarget: undefined,
};
